import axios from './axios-util'
import { getUserType } from './user-utils'

const LIVE = 'live'
const SANDBOX = 'sandbox'

export const saveBannerProgress = (csrf, logger, sessionObject) => {
  axios({
    method: 'post',
    url: '/dashboard/bannerProgress',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-csrf-token': csrf,
    },
    data: { sessionObject },
    responseType: 'json',
    contentType: 'application/json',
  }).then(({ data }) => {
    if (data?.message === 'success') {
      logger.info('Onboarding Banner progress saved successfully.')
    } else {
      logger.info(' Onboarding Banner progress failed to save.')
    }
  })
}

export const getCurrentEnvironment = (user) => {
  let environment = window.localStorage.getItem('environment') || SANDBOX

  if (user && getUserType(user) !== 'BUSINESS') {
    window.localStorage.setItem('environment', SANDBOX)
    return SANDBOX
  }

  if (environment === LIVE || environment === SANDBOX) {
    return environment
  }

  window.localStorage.setItem('environment', SANDBOX)
  return SANDBOX
}

export const getDateRangeSelection = () => {
  let dateRange = window.localStorage.getItem('dateRange') || undefined

  return dateRange
}

export const getAppSelection = () => {
  let appSelection = window.localStorage.getItem('appSelection') || undefined

  return appSelection
}

export const setAppSelection = (appSwitcherSelection) => {
  window.localStorage.setItem('appSelection', appSwitcherSelection)
}

export const clearLocalStorage = (key) => {
  if (key) {
    window.localStorage.removeItem(key)
  } else {
    window.localStorage.removeItem('environment')
    window.localStorage.removeItem('dateRange')
    window.localStorage.removeItem('appSelection')
  }
}

export const logoutHandler = () => {
  clearLocalStorage()
}
